import * as React from 'react';
import { Link } from 'ui/link';
import { toAbsoluteUrl } from 'app/infrastructure/hosting';
import { routeConstants } from 'app/routes/route-constants';

interface TooltipCaseNumberProps {
  value: string;
}

export const TooltipCaseNumber: React.FC<TooltipCaseNumberProps> = ({ value }) => {

  return !!value &&
    <Link url={toAbsoluteUrl(routeConstants.caseViewFor(value))}>
      {value}
    </Link>;
};
